import useSWR, { Fetcher, SWRConfiguration, SWRResponse } from 'swr'

import { fetcher } from '@/utils/fetcher'

export type ApiVersion = {
  version: string
  buildId: string
}

export const useApiVersion = <
  Options extends SWRConfiguration<
    ApiVersion,
    unknown,
    Fetcher<ApiVersion, string>
  > = SWRConfiguration<ApiVersion, unknown, Fetcher<ApiVersion, string>>,
>(
  options?: Options,
): SWRResponse<ApiVersion, unknown, Options & { fallbackData: ApiVersion }> => {
  const fallbackData = {
    version: process.env.NEXT_PUBLIC_VERSION!,
    buildId: process.env.NEXT_PUBLIC_BUILD_ID!,
  }

  return useSWR<ApiVersion, unknown, string>('/api/version/latest', fetcher, {
    fallbackData,
    ...(options ?? {}),
  })
}
